module.exports = __webpack_public_path__ + "img/outofdate.97391a13.png";